import React from 'react';
import { IconProps } from './types';

const ShoppingCartLight: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8528 15.9721H8.26439C7.83198 15.9721 7.57254 15.7127 7.39958 15.3668L5.15108 7.32408C5.0646 7.06463 5.15108 6.80519 5.32404 6.54575C5.49701 6.37279 5.75645 6.19983 6.01589 6.19983H22.1013C22.3607 6.19983 22.6202 6.28631 22.7931 6.54575C22.9661 6.71871 23.0526 7.06463 22.9661 7.32408C22.1878 10.005 21.4959 12.6859 20.7176 15.3668C20.6311 15.7127 20.2852 15.9721 19.8528 15.9721ZM8.86975 14.2425H19.1609C19.7663 12.167 20.2852 10.005 20.8906 7.92944H7.14014L8.86975 14.2425Z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      d="M8.26437 15.9721C7.91845 15.9721 7.57253 15.7126 7.39956 15.3667L4.5457 4.81609L1.86481 4.72961C1.34592 4.72961 1 4.29721 1 3.86481C1 3.34592 1.4324 3 1.86481 3L5.15107 3.17296C5.49699 3.17296 5.84291 3.4324 5.92939 3.77832L8.95621 14.9343C9.04269 15.3667 8.78325 15.8856 8.35085 15.9721C8.43733 15.9721 8.35085 15.9721 8.26437 15.9721Z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      d="M10.3399 21.161C9.04269 21.161 7.91844 20.1232 7.91844 18.7395C7.91844 17.4423 8.95621 16.4045 10.3399 16.4045C11.6371 16.4045 12.7614 17.4423 12.7614 18.7395C12.6749 20.1232 11.6371 21.161 10.3399 21.161ZM10.3399 18.1342C9.99398 18.1342 9.64805 18.3936 9.64805 18.826C9.64805 19.1719 9.9075 19.5178 10.3399 19.5178C10.6858 19.5178 11.0317 19.2584 11.0317 18.826C10.9453 18.3936 10.6858 18.1342 10.3399 18.1342Z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      d="M17.5178 21.161C16.2206 21.161 15.0963 20.1232 15.0963 18.7395C15.0963 17.4423 16.1341 16.4045 17.5178 16.4045C18.815 16.4045 19.9392 17.4423 19.9392 18.7395C19.9392 20.1232 18.815 21.161 17.5178 21.161ZM17.5178 18.1342C17.1719 18.1342 16.8259 18.3936 16.8259 18.826C16.8259 19.1719 17.0854 19.5178 17.5178 19.5178C17.8637 19.5178 18.2096 19.2584 18.2096 18.826C18.2096 18.3936 17.8637 18.1342 17.5178 18.1342Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default ShoppingCartLight;
